import type { Locale } from "../types/locale";

export interface UICopy {
  placeholder: string;
  bottomCtaLabel: string;
  restartLabel: string;
  languageSwitcherLabel: string;
  switchToEnglishLabel: string;
  switchToFilipinoLabel: string;
}

export const UI_COPY: Record<Locale, UICopy> = {
  en: {
    placeholder: "Tap one of the options above",
    bottomCtaLabel: "Apply now",
    restartLabel: "Restart",
    languageSwitcherLabel: "Language switcher",
    switchToEnglishLabel: "Switch language to English",
    switchToFilipinoLabel: "Switch language to Filipino",
  },
  fil: {
    placeholder: "Piliin ang isa sa mga opsyon sa itaas",
    bottomCtaLabel: "Mag-apply ngayon",
    restartLabel: "Magsimula ulit",
    languageSwitcherLabel: "Pagpili ng wika",
    switchToEnglishLabel: "Palitan ang wika sa English",
    switchToFilipinoLabel: "Palitan ang wika sa Filipino",
  },
};
